var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16L0 8L10 0V5C15.523 5 20 9.477 20 15C20 15.273 19.99 15.543 19.968 15.81C18.505 13.036 15.638 11.119 12.313 11.005L12 11H10V16ZM8 9H12.034L12.381 9.007C13.666 9.05 14.905 9.317 16.057 9.773C14.59 8.075 12.42 7 10 7H8V4.161L3.202 8L8 11.839V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.a7757da1e359258d0c216e4cd358a826.svg";
export { ForwardRef as ReactComponent };